import { useSelector } from 'react-redux';

import { slices } from '~/redux/slices';
import { Client } from '~/types/Client';

/**
 * TODO: this hook is very inefficient/slow.  Avoid using it if possible.
 * - Refactor to source data from a simple GET /client endpoint.
 * - Use this hook only if you need information such as client `folderTree` or `dataFields` (but these should exist in separate resource endpoints in the first place).
 * - Use `useCurrentUser().client` to obtain a client ID instead
 */

//! only used in useDepartments and useSearchMentionWithPermissions to get client ID, type should be ClientState
export const useClient = (): Client => {
  const client = useSelector(
    slices.client.selectors.selectClient,
  ) as unknown as Client;
  return client;
};
